interface Props {
  openCount: number;
  audioEnabled: boolean;
  onEnableAudio: () => void;
}

// Deutlich sichtbarer Alarmbereich, sobald >=1 awaiting_merchant-Order
// existiert. Alarm nicht nur über Farbe (Text + Symbol + Zahl + ARIA).
export function AlarmBanner({ openCount, audioEnabled, onEnableAudio }: Props) {
  if (openCount <= 0) {
    return (
      <div className="alarm alarm--idle" role="status" aria-live="polite">
        <span className="alarm__icon" aria-hidden="true">✓</span>
        <span>Keine offenen Bestellungen. Terminal bereit.</span>
        {!audioEnabled && (
          <button className="btn btn--small" onClick={onEnableAudio}>Ton aktivieren</button>
        )}
      </div>
    );
  }
  return (
    <div className="alarm alarm--active" role="alert" aria-live="assertive">
      <span className="alarm__icon" aria-hidden="true">🔔</span>
      <span className="alarm__text">
        <strong>{openCount}</strong> {openCount === 1 ? "Bestellung wartet" : "Bestellungen warten"} auf deine Entscheidung.
      </span>
      {!audioEnabled && (
        <button className="btn btn--small" onClick={onEnableAudio}>Ton aktivieren</button>
      )}
    </div>
  );
}
